module.exports = __webpack_public_path__ + "static/media/Club.1bd6fb70.jpg";